import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createExternalRelationInterestAsync, deleteExternalRelationInterestAsync, getExternalRelationInterestByIdAsync, getExternalRelationInterestsByRelationIdAsync, updateExternalRelationInterestAsync } from './externalRelationInterestsThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const externalRelationInterestsSlice = createSlice({
    name: 'externalRelationInterests',
    initialState,
    reducers: {
        resetExternalRelationInterestsApiState(state) {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            // Create
            .addCase(createExternalRelationInterestAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createExternalRelationInterestAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.externalRelationInterest = action.payload;
            if (state.externalRelationInterests && Array.isArray(state.externalRelationInterests)) {
                state.externalRelationInterests.push(action.payload);
            }
        })
            .addCase(createExternalRelationInterestAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Update
            .addCase(updateExternalRelationInterestAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateExternalRelationInterestAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.externalRelationInterest = action.payload;
            if (state.externalRelationInterests && Array.isArray(state.externalRelationInterests)) {
                const idx = state.externalRelationInterests.findIndex((x) => x.id === action.payload.id);
                if (idx >= 0)
                    state.externalRelationInterests[idx] = action.payload;
            }
        })
            .addCase(updateExternalRelationInterestAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Delete
            .addCase(deleteExternalRelationInterestAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteExternalRelationInterestAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deleteExternalRelationInterestAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Get By Id
            .addCase(getExternalRelationInterestByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getExternalRelationInterestByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.externalRelationInterest = action.payload;
        })
            .addCase(getExternalRelationInterestByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            // Get By Relation Id
            .addCase(getExternalRelationInterestsByRelationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getExternalRelationInterestsByRelationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.paginatedExternalRelationInterests = action.payload;
        })
            .addCase(getExternalRelationInterestsByRelationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { resetExternalRelationInterestsApiState } = externalRelationInterestsSlice.actions;
export default externalRelationInterestsSlice.reducer;
